import { ROUTE_PERMISSIONS_MANAGER } from '@shared';
import { newPermissions } from '@shared/newPermissions';

import { PermissionsManagerPage } from './PermissionsManagerPage';

export const routes = {
  [ROUTE_PERMISSIONS_MANAGER]: {
    path: '/permissionsManager',
    Component: PermissionsManagerPage,
    titleId: 'page.permissionsManager',
    permission: newPermissions.VIEW_PERMISSIONS_MANAGER,
  },
};
